import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertComponent } from './alert.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { TranslateModule } from '@ngx-translate/core';
import { KupariInputCollectionModule } from '@app/shared/input-collection.module';


@NgModule({
  declarations: [
    AlertComponent
  ],
  imports: [
    CommonModule,
    MatProgressBarModule,
    TranslateModule,
    KupariInputCollectionModule
  ],
  exports: [
    AlertComponent
  ]
})
export class AlertModule { }
